import { render } from "./ElevationDemo.vue?vue&type=template&id=57d5e13a&scoped=true"
import script from "./ElevationDemo.vue?vue&type=script&lang=js"
export * from "./ElevationDemo.vue?vue&type=script&lang=js"

import "./ElevationDemo.vue?vue&type=style&index=0&id=57d5e13a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d5e13a"]])

export default __exports__